import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-sim-consumption-period-selector',
  template: require('./sim-consumption-period-selector.component.html'),
  styles: [require('./sim-consumption-period-selector.component.sass')],

})
export class SimConsumptionPeriodSelectorComponent implements OnInit, OnDestroy {

  @ViewChild('simPeriodExportModal') simPeriodExportModal: ElementRef;
  @Output() select = new EventEmitter<{
    dateFrom: string | null,
    dateTo: string | null
  }>();

  yearRange: string;
  selectedMonth: Date;
  maxDateTime = new Date();

  simPeriodExportModalReference: NgbModalRef;
  languageChangeSubscription: Subscription;

  
  constructor(
    private modalService: NgbModal,
    private datePipe: DatePipe
  ) {
   }

  ngOnInit(): void {
    this.selectedMonth = new Date();
    this.selectedMonth.setDate(1);
    const maxYear = new Date().getFullYear();
    const minYear = maxYear - 5;
    this.yearRange = `${minYear}:${maxYear}`;
  }

  async showModal() {
    this.simPeriodExportModalReference = await this.modalService.open(this.simPeriodExportModal, {
      backdrop: 'static',
      size: 'lg'
    });
  }

  export = () => {
    if (this.selectedMonth) {
      const from = new Date(this.selectedMonth);
      from.setHours(0);
      from.setMinutes(0);
      from.setSeconds(0);
      const to = new Date(from.getFullYear(), from.getMonth()+1, 0);
      to.setHours(23);
      to.setMinutes(59);
      to.setSeconds(59);
      
      this.select.emit({
        dateFrom: this.datePipe.transform(from, "yyyy-MM-dd'T'HH:mm:ss+00",),
        dateTo: this.datePipe.transform(to, "yyyy-MM-dd'T'HH:mm:ss+00")
      });
      this.simPeriodExportModalReference.close();
   } else {

   }
  }

  selectRelativeMonth(monthDifference: number) {
    const targetMonth = new Date(this.selectedMonth);
    targetMonth.setDate(1);
    targetMonth.setMonth(targetMonth.getMonth() + monthDifference);
    this.selectedMonth = targetMonth
  }

  isCurrentMonth() {
    return (this.selectedMonth.getMonth() === this.maxDateTime.getMonth()) && 
      (this.selectedMonth.getFullYear() === this.maxDateTime.getFullYear())
  }
  

  ngOnDestroy() {
    if (this.languageChangeSubscription) {
      this.languageChangeSubscription.unsubscribe();
    }
  }
}
